import { render, staticRenderFns } from "./NGNWallet.vue?vue&type=template&id=46a9e085&"
import script from "./NGNWallet.vue?vue&type=script&lang=js&"
export * from "./NGNWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports